import React from 'react';

import { useMemo, useEffect } from 'react';

import Polyline from '../../../../components/maps/Polyline';

import { stringToColor } from '../../../../lib/utils/stringColor';

import useRouteCoordinates from '../../../../hooks/useRouteCoordinate';

import './GpsgateCoordinates.css';

const GpsgatePath = ({ route_id, coordinates = [], segments = {} }) => {
    //const { coordinates = [], fetchCoordinates } = useRouteCoordinates();

    /*
    useEffect(() => {
        fetchCoordinates(route_id);
    }, [ route_id, fetchCoordinates ]);
    */

    /*
    const coloredPath = useMemo(() => {

        if (coordinates === null) {
            return [];
        }

        let key = 0;

        let lastPlannedRouteId = undefined;
        let lastDriver = undefined;

        const path = coordinates.reduce((acc, { latitude, longitude, driver, planned_route_id, updatedTime }) => {
   
            if (!acc['p' + key]) {
                acc['p' + key] = { 
                    path: [ { lat: latitude, lng: longitude } ], 
                    driver: driver, 
                    planned_route_id: planned_route_id,
                    color: planned_route_id !== null ? '#57004e' : (driver ? stringToColor(driver, { saturation: 90, lightness: 50 }) : '#bdbdbd')
                };
            } else {
                acc['p' + key].path.push({ lat: latitude, lng: longitude });
            }

            if (lastPlannedRouteId === undefined) {
                lastPlannedRouteId = planned_route_id;
                lastDriver = driver;
                key = planned_route_id !== null ? planned_route_id : driver;
            } else if (lastPlannedRouteId !== planned_route_id || lastDriver !== driver) {
                key = planned_route_id !== null ? planned_route_id : driver;
                lastPlannedRouteId = planned_route_id;
                lastDriver = driver;
            }

            return acc;

        }, {});

        return Object.values(path);
    
    }, [ coordinates ]);
*/
    const coloredPath = useMemo(() => {

        if (coordinates === null) {
            return [];
        }

        const path = {};

        Object.values(segments).forEach(({ key, driver, planned_route_id, coordinates, driverColor }) => {
            if (!path[key]) {
                path[key] = {
                    path: coordinates.map(({ latitude, longitude }) => ({ lat: latitude, lng: longitude })),
                    driver,
                    planned_route_id,
                    color: driverColor
                };
            }

        });

        return Object.values(path);
    
    }, [ segments ]);

    return (
        <>

            {
                coloredPath
                &&
                <>
                    {
                        coloredPath.map(({ path, color, driver }, index) => {

                            return (
                                <Polyline 
                                    key={'path' + index}
                                    path={path} 
                                    strokeOpacity={1} 
                                    strokeColor={color}
                                    strokeWeight={3}
                                    icons={[{
                                        icon: {
                                            path: window.google.maps.SymbolPath.FORWARD_OPEN_ARROW,
                                            scale: 2.5
                                        },
                                        repeat: '200px'
                                    }]}
                                />
                            )

                        })
                        
                    }
                </>
         
             
            }
        </>
    )

}

export default GpsgatePath;
